import createIcon from '../../createIcon';

/**
 * @component @name MotionPhotosPaused
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMTJDMjIgMTcuNTIgMTcuNTIgMjIgMTIgMjJDNi40OCAyMiAyIDE3LjUyIDIgMTJDMiAxMC44MSAyLjIyIDkuNjggMi42IDguNjJMNC40OCA5LjNDNC4xNyAxMC4xNCA0IDExLjA1IDQgMTJDNCAxNi40MSA3LjU5IDIwIDEyIDIwQzE2LjQxIDIwIDIwIDE2LjQxIDIwIDEyQzIwIDcuNTkgMTYuNDEgNCAxMiA0QzExLjA1IDQgMTAuMTUgNC4xNyA5LjMxIDQuNDhMOC42MyAyLjU5QzkuNjkgMi4yMiAxMC44MiAyIDEyIDJDMTcuNTIgMiAyMiA2LjQ4IDIyIDEyWk01LjUgNEM0LjY3IDQgNCA0LjY3IDQgNS41QzQgNi4zMyA0LjY3IDcgNS41IDdDNi4zMyA3IDcgNi4zMyA3IDUuNUM3IDQuNjcgNi4zMyA0IDUuNSA0Wk0xMSAxNlY4SDlWMTZIMTFaTTE1IDE2VjhIMTNWMTZIMTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MotionPhotosPaused = createIcon('MotionPhotosPaused', [
  [
    'path',
    {
      d: 'M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 10.81 2.22 9.68 2.6 8.62L4.48 9.3C4.17 10.14 4 11.05 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C11.05 4 10.15 4.17 9.31 4.48L8.63 2.59C9.69 2.22 10.82 2 12 2C17.52 2 22 6.48 22 12ZM5.5 4C4.67 4 4 4.67 4 5.5C4 6.33 4.67 7 5.5 7C6.33 7 7 6.33 7 5.5C7 4.67 6.33 4 5.5 4ZM11 16V8H9V16H11ZM15 16V8H13V16H15Z',
      key: '1p93xv',
    },
  ],
]);

export default MotionPhotosPaused;
